export const ERROR_MESSAGE_MAP = {
    insufficient_karma: 'You do not have enough karma to unlock this chapter',
} as const;
export const ERROR_REASONS_TO_BUY_KARMA = ['insufficient_karma', 'regular_karma_exceeded'];
